export const repositoriosRoutes = [
  {
    path: '/respositorios',
    name: 'Repositorios',
    component: () =>
      import(
        /* webpackChunkName: "respositorios" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiFolderPlayOutline',
    typeIcon: 'mdi',
    menu: false,
    desplegable: true,
    meta: {
      title: 'Repositorios',
      requiresSession: true,
      perfiles: [],
      showBackButton: false
    },
    children: [
      {
        path: '/respositorios/create',
        name: 'RepositoriosCreate',
        component: () =>
          import(
            /* webpackChunkName: "respositorios" */ '@/modules/Respositorios/views/RepositoriosForm.vue'
          ),
        icon: 'mdiAlert',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Formulario de Repositorios',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: true
        },
        children: []
      },
      {
        path: '/respositorios/update/:id',
        name: 'RepositoriosUpdate',
        component: () =>
          import(
            /* webpackChunkName: "respositorios" */ '@/modules/Respositorios/views/RepositoriosForm.vue'
          ),
        icon: 'mdiAlert',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Formulario de Repositorios',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: true
        },
        children: []
      },
      {
        path: '/recursos/',
        name: 'RecursosIndex',
        component: () =>
          import(
            /* webpackChunkName: "respositorios" */ '@/modules/Respositorios/views/RecursosIndex.vue'
          ),
        icon: 'mdiPlayNetworkOutline',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Recursos',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      }
    ]
  }
]
